export default __webpack_public_path__ + "static/Ahmed-Ali-1-d1adecca60d56c9febe0e44d69981d79.png";